'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var grey = {};

exports.__exports = grey;
